import type { ReactNode } from 'react';
import { BackLink } from './BackLink';
import styles from './TestIntro.module.css';

/**
 * The top of a paper test's page: the way back to the overview, the title
 * row, a one-line summary, and the full explanation folded under "How this
 * test works" so the scorecard is on the first screen.
 */
export function TestIntro({
  heading,
  summary,
  children,
}: {
  /** The title row (h1 and refresh status). */
  heading: ReactNode;
  summary: string;
  children: ReactNode;
}) {
  return (
    <>
      <BackLink to="/paper-tests" label="Paper tests" />
      {heading}
      <div className={styles.intro}>
        <p className={styles.summary}>{summary}</p>
        <details className={styles.more}>
          <summary className={styles.toggle}>How this test works</summary>
          <div className={styles.body}>{children}</div>
        </details>
      </div>
    </>
  );
}
